export default __webpack_public_path__ + "static/spa_w.f70f4e23d695c73139bb6b5f0761f1ab.svg";